import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyCz7d_feOXuOIOuorhqXnJ4hS7z_P2DW1s',
  authDomain: 'email-cleaner.app',
  projectId: 'email-cleaner-a7416',
  storageBucket: 'email-cleaner-a7416.firebasestorage.app',
  messagingSenderId: '440005072455',
  appId: '1:440005072455:web:56065874995fb8e5878362',
  measurementId: 'G-2102Z8YX4P',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const getSubscriptionStatus = httpsCallable(functions, 'getSubscriptionStatus');
